import React from 'react';
import classNames from 'classnames';

import './WpButtonGroup.scss';

type Spacing = 'sm' | 'md' | 'lg' | 'none';
const DEFAULT_SPACING = 'lg';

export interface Props {
  spacing?: Spacing;
  block?: boolean;
  stacked?: boolean;
  children: React.ReactNode;
}

const WpButtonGroup: React.FC<Props> = ({
  children,
  block = false,
  stacked = false,
  spacing = DEFAULT_SPACING,
}: Props) => {
  const classNamePrefix = 'WpButtonGroup';
  const classes = classNames(
    classNamePrefix,
    `${classNamePrefix}--spacing-${spacing}`,
    block ? `${classNamePrefix}--block` : false,
    stacked ? `${classNamePrefix}--stacked` : false
  );

  return <div className={classes}>{children}</div>;
};

export default WpButtonGroup;
